<script lang="ts">
	import type { WidgetState } from '../lib/widget.svelte';

	let { widget }: { widget: WidgetState } = $props();

	let videoEl: HTMLVideoElement | null = $state(null);
	let stream: MediaStream | null = null;
	let cameraError = $state('');
	let captured = $state<string | null>(null);

	$effect(() => {
		// Arranca la cámara al montar y libera los tracks al desmontar
		(async () => {
			try {
				stream = await navigator.mediaDevices.getUserMedia({
					video: { facingMode: 'user', width: { ideal: 1080 }, height: { ideal: 1440 } },
					audio: false
				});
				if (videoEl) {
					videoEl.srcObject = stream;
					await videoEl.play();
				}
			} catch {
				cameraError = 'No se pudo acceder a la cámara. Revisá los permisos del navegador.';
			}
		})();

		return () => {
			stream?.getTracks().forEach((track) => track.stop());
			stream = null;
		};
	});

	function capture() {
		if (!videoEl) return;
		const canvas = document.createElement('canvas');
		canvas.width = videoEl.videoWidth;
		canvas.height = videoEl.videoHeight;
		const ctx = canvas.getContext('2d')!;
		// Espeja la captura para que coincida con el preview
		ctx.translate(canvas.width, 0);
		ctx.scale(-1, 1);
		ctx.drawImage(videoEl, 0, 0);
		captured = canvas.toDataURL('image/png');
	}

	function usePhoto() {
		if (!captured) return;
		widget.processSelfie(captured);
	}
</script>

<div class="ss-camera">
	{#if cameraError}
		<p class="ss-camera-error">{cameraError}</p>
		<button type="button" class="ss-btn ss-btn-block" onclick={() => widget.backToGallery()}>
			← Volver a las plantillas
		</button>
	{:else}
		<div class="ss-video-wrap">
			{#if captured}
				<img src={captured} alt="Captura" style="width:100%;height:100%;object-fit:cover" />
			{:else}
				<!-- svelte-ignore a11y_media_has_caption -->
				<video bind:this={videoEl} playsinline muted></video>
				<button type="button" class="ss-btn-capture" onclick={capture} aria-label="Tomar foto"></button>
			{/if}
		</div>

		{#if captured}
			<div class="ss-actions">
				<button type="button" class="ss-btn" onclick={() => (captured = null)}>↺ Repetir</button>
				<button type="button" class="ss-btn ss-btn-primary" onclick={usePhoto}>Usar esta foto →</button>
			</div>
		{:else}
			<button type="button" class="ss-btn ss-btn-block" onclick={() => widget.backToGallery()}>
				← Volver a las plantillas
			</button>
		{/if}
	{/if}
</div>
